module.exports = __webpack_public_path__ + "img/acbb852.jpg";